import Icon from "../Icon/Icon";

export default function Spinner() {
    return (
        <div className="flex items-center justify-center h-screen">
            <Icon icon="spinner" className="animate-spin text-primary text-4xl" />
        </div>
    );
}
